import React from 'react';

const StatsIcon = () => {
    return (
        <svg width={28.667} height={26.001} viewBox="0 0 28.667 26.001">
            <path
                d="M27.667 13h-5.333l-4 12-8-24-4 12H1"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default StatsIcon;
